import React from 'react';
import { Column } from "rbx";
import "../../../styles/user.scss";
import Layout from "../../layout";
import UserForm from '../../../components/components/UserForm';

const UserNewScreen = () => (
  <Layout>
    <Column.Group centered>
      <Column size={5}>
        <UserForm newRecord={true} />
      </Column>
    </Column.Group>
  </Layout>
);

export default UserNewScreen;
